import { render } from "./TheContentHeader.vue?vue&type=template&id=e35c0278"
import script from "./TheContentHeader.vue?vue&type=script&lang=js"
export * from "./TheContentHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__